import { render } from "./Select-Chain.vue?vue&type=template&id=4423c37f&scoped=true"
import script from "./Select-Chain.vue?vue&type=script&lang=js"
export * from "./Select-Chain.vue?vue&type=script&lang=js"

import "./Select-Chain.vue?vue&type=style&index=0&id=4423c37f&scoped=true&lang=css"

import exportComponent from "C:\\Users\\User\\OneDrive\\工作案件\\前端管理介面\\vue3-adminlte3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4423c37f"]])

export default __exports__